import apiCustomFieldService from '@/services/api/common/customFieldService';
export default {
  async getGroups(context) {
    const groupsResponse = await apiCustomFieldService.getGroups();
    context.commit('setCustomFieldGroups', { groups: groupsResponse || {} });
  },
};
